
export const Loader = () => (
    <div className="flex items-center justify-center h-full bg-white">
        <div className="flex flex-col items-center gap-3">
            <div className="w-10 h-10 border-4 border-gray-200 border-t-blue-600 rounded-full animate-spin" />
            <span className="text-sm text-gray-500 tracking-wide">
                Loading, please wait...
            </span>
        </div>
    </div>
);